import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

async function isAccessAllowed(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> {
  const keycloakService = inject(KeycloakService);

  // Force the user to log in if currently unauthenticated.
  const isLoggedIn = await keycloakService.isLoggedIn();
  if (!isLoggedIn) {
    await keycloakService.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  // Get the roles required from the route.
  const requiredRoles = route.data['roles'];

  // Allow the user to proceed if no additional roles are required to access the route.
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    return true;
  }

  // Get user roles from Keycloak
  const userRoles = keycloakService.getUserRoles();

  // Allow the user to proceed if all the required roles are present.
  return requiredRoles.every((role) => userRoles.includes(role));
}

export const AuthGuard: CanActivateFn = (route, state) => {
  return isAccessAllowed(route, state);
};

export const AuthGuardChild: CanActivateChildFn = (route, state) => {
  return isAccessAllowed(route, state);
};
